import { differenceInHours, differenceInMinutes } from 'date-fns';

/*
  Future-relative wait for the preset check-back message: short waits read as
  hours (soft cooldowns), long ones as days (full cooldowns can be 14 days).
  Returns null when the target is missing, invalid or already passed.
*/
export function timeUntil(target, now = new Date()) {
  if (!target) return null;

  const date = new Date(target);
  if (isNaN(date.getTime()) || date <= now) return null;

  const hours = differenceInHours(date, now);

  if (hours < 48) {
    return { unit: 'hours', count: Math.max(1, Math.ceil(differenceInMinutes(date, now) / 60)) };
  }

  return { unit: 'days', count: Math.ceil(hours / 24) };
}
